import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
var CordataError = function CordataError(props) {
  return React.createElement('div', {
    className: 'text-center py-3'
  }, React.createElement(FontAwesomeIcon, {
    icon: 'minus-circle',
    size: '3x',
    className: 'mb-3 text-danger'
  }), React.createElement('h6', {
    className: 'text-danger'
  }, 'Error Occured'), props.message && React.createElement('p', null, props.message));
};
CordataError.propTypes = {
  message: PropTypes.string
};
CordataError.defaultProps = {
  message: undefined
};
export default CordataError;